import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TranslocoService } from '@jsverse/transloco';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-consumption-and-costs-right-chart',
  standalone: true,
  imports: [ChartModule],
  providers: [DecimalPipe],
  templateUrl: './consumption-and-costs-right-chart.component.html',
  styleUrl: './consumption-and-costs-right-chart.component.css'
})
export class ConsumptionAndCostsRightChartComponent implements OnInit, OnChanges {
  data: any;
  options: any;

  labels: string[] = ['F1', 'F2', 'F3'];

  // Dummy data
  @Input() showDummyData: boolean = false;
  dummyf1data: (number | null)[] = [31000, null, null];
  dummyf2data: (number | null)[] = [null, 28000, null];
  dummyf3data: (number | null)[] = [null, null, 31000];
  dummyf1eurperkwh: number = 0.11;
  dummyf2eurperkwh: number = 0.11;
  dummyf3eurperkwh: number = 0.11;

  @Input() f1data: (number | null)[] = [31000, null, null];
  @Input() f2data: (number | null)[] = [null, 28000, null];
  @Input() f3data: (number | null)[] = [null, null, 31000];

  @Input() f1eurperkwh: number = 0.11;
  @Input() f2eurperkwh: number = 0.11;
  @Input() f3eurperkwh: number = 0.11;

  constructor(private translocoService: TranslocoService, private decimalPipe: DecimalPipe) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateChart();
  }

  ngOnInit(): void {
    this.updateChart();
  }

  updateChart(): void {
    if(this.showDummyData)
    {
      this.f1data = this.dummyf1data;
      this.f2data = this.dummyf2data;
      this.f3data = this.dummyf3data;
      this.f1eurperkwh = this.dummyf1eurperkwh;
      this.f2eurperkwh = this.dummyf2eurperkwh;
      this.f3eurperkwh = this.dummyf3eurperkwh;
    }

    Chart.register(ChartDataLabels);

    this.data = {
      labels: this.labels,
      datasets: [
        {
          type: 'bar',
          label: `${this.decimalPipe.transform(this.f1eurperkwh, '1.2-2') || this.f1eurperkwh}€/kWh`,
          backgroundColor: ['#769257', '#A9BE92', '#BDCAAC'],
          data: this.f1data,
          stack: 'consumption',
          borderRadius: 12,
          datalabels: {
            display: (ctx: any) => ctx.raw !== null,
            color: '#000000',
            font: {
              size: 12,
              weight: 'normal',
              family: 'Gilroy',
            },
            formatter: (value: number | null) => value !== null ? `${this.decimalPipe.transform(value, '1.0-0') || value} kWh` : '',
          },
        },
        {
          type: 'bar',
          label: `${this.decimalPipe.transform(this.f2eurperkwh, '1.2-2') || this.f2eurperkwh}€/kWh`,
          backgroundColor: ['#769257', '#A9BE92', '#BDCAAC'],
          data: this.f2data,
          stack: 'consumption',
          borderRadius: 12,
          datalabels: {
            display: (ctx: any) => ctx.raw !== null,
            color: '#000000',
            font: {
              size: 12,
              weight: 'normal',
              family: 'Gilroy',
            },
            formatter: (value: number | null) => value !== null ? `${this.decimalPipe.transform(value, '1.0-0') || value} kWh` : '',
          },
        },
        {
          type: 'bar',
          label: `${this.decimalPipe.transform(this.f3eurperkwh, '1.2-2') || this.f3eurperkwh}€/kWh`,
          backgroundColor: ['#769257', '#A9BE92', '#BDCAAC'],
          data: this.f3data,
          stack: 'consumption',
          borderRadius: 12,
          datalabels: {
            display: (ctx: any) => ctx.raw !== null,
            color: '#000000',
            font: {
              size: 12,
              weight: 'normal',
              family: 'Gilroy',
            },
            formatter: (value: number | null) => value !== null ? `${this.decimalPipe.transform(value, '1.0-0') || value} kWh` : '',
          },
        },
      ],
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            font: {
              size: 12,
            },
          },
        },
        datalabels: {
          anchor: 'center',
          align: 'center',
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const index = context.dataIndex;
              let label = context.dataset.label || '';
              let value = context.raw || 0;
              return `${label}: ${this.decimalPipe.transform(value, '1.0-0') || value}`;
            }
          }
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            font: {
              size: 12,
              weight: 'normal',
              family: 'Gilroy',
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          display: false,
          grid: {
            display: false,
          },
          ticks: {
            callback: (value: number) => `${this.decimalPipe.transform(value, '1.0-0') || value} kWh`,
          },
        },
      },
    };
  }
}
